import { Component } from "react";
import axios from "axios";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter";
import { funcNavigate } from "../../../../settings/utils/functions";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { header } from "../../components/header";
import { footer } from "../../components/footer";
import { toastAlerts } from "../../../../settings/utils/toastify";
import { BASE_URL, TIMEOUT } from "../../../../settings/utils/config";

class Login extends Component {
    static contextType = simplyContext;

    state = {
        phoneNumber: "",
        password: "",
        website: "",
        errors: {},
        generalError: "",
        loading: false,
        checkingAuth: true,
    };

    componentDidMount() {
        window.scrollTo(0, 0);

        const token = sessionStorage.getItem("authorization");

        if (token) {
            this.context.fPreloader(true);
            this.context.fNavigate("/profile");
        } else {
            this.context.fPreloader(false);
            this.setState({ checkingAuth: false });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            [name]: value,
            errors: { ...prev.errors, [name]: "" },
        }));
    };

    validate = () => {
        const { phoneNumber, password } = this.state;
        const errors = {};

        if (!phoneNumber.trim()) {
            errors.phoneNumber = "شماره همراه الزامی است";
        } else if (!/^09\d{9}$/.test(phoneNumber)) {
            errors.phoneNumber = "شماره همراه معتبر نیست";
        }

        if (!password.trim()) {
            errors.password = "کلمه عبور الزامی است";
        }

        const hasError = Object.keys(errors).length > 0;

        this.setState({
            errors,
            generalError: hasError ? "خطاهای فرم را بررسی کنید" : "",
        });

        return !hasError;
    };

    scrollToFormTop = () => {
        setTimeout(() => {
            const el = document.getElementById("login-form-top");
            if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }, 100);
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ generalError: "" });

        if (!this.validate()) {
            this.scrollToFormTop();
            return;
        }
        if (this.state.loading) return;

        this.setState({ loading: true });

        axios.post(
            BASE_URL + "/api/v1/accounts/login/",
            {
                phoneNumber: this.state.phoneNumber,
                password: this.state.password,
                website: this.state.website,
            },
            {
                timeout: TIMEOUT,
                headers: { "Content-Type": "application/json" },
            }
        ).then((response) => {
            const data = response.data;

            if (data.code === "success") {
                sessionStorage.setItem("authorization", data.token);
                this.context.fSetLoggedIn(true);
                this.props.navigate("/profile");
            } else {
                toastAlerts(response);
            }
            this.setState({ loading: false });
        }).catch((error) => {
            toastAlerts(error.response);
            this.setState({ loading: false });
        });
    };

    render() {
        const { phoneNumber, password, website, errors, generalError, loading, checkingAuth } = this.state;

        if (checkingAuth) {
            return (
                <HelmetProvider>
                    <Helmet>
                        <title>ورود | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    </Helmet>
                    {null}
                </HelmetProvider>
            );
        }

        return (
            <HelmetProvider>
                <Helmet>
                    <title>ورود | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    <link rel="canonical" href="https://nasrme.ac.ir" />
                </Helmet>

                <div className="container-fluid cFlex1 cBg3">
                    {header(this.context)}

                    <div className="row">
                        <div className="col-12 px-0">
                            <div className="login-page">

                                <div className="login-bg">
                                    <div className="login-bg-overlay" />
                                </div>

                                <div className="login-wrapper" id="login-form-top">
                                    <div className="login-card">
                                        <div className="text-center mb-3">
                                            <img src="/images/logo.png" className="img-fluid w-50" alt="لوگو" />
                                        </div>

                                        <h1 className="login-title">ورود به حساب کاربری</h1>
                                        <p className="login-subtitle">
                                            شماره همراه و کلمه عبور خود را وارد کنید
                                        </p>

                                        {generalError && (
                                            <div className="login-general-error">
                                                {generalError}
                                            </div>
                                        )}

                                        <form onSubmit={this.handleSubmit} className="login-form" noValidate>

                                            <div className="hp-field" aria-hidden="true">
                                                <label htmlFor="website">وب‌سایت</label>
                                                <input
                                                    id="website"
                                                    name="website"
                                                    type="text"
                                                    value={website}
                                                    onChange={this.handleChange}
                                                    tabIndex={-1}
                                                    autoComplete="off"
                                                />
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="phoneNumber">شماره همراه</label>
                                                <input
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    type="text"
                                                    value={phoneNumber}
                                                    onChange={this.handleChange}
                                                    placeholder="شماره همراه خود را وارد کنید"
                                                     autoComplete='off'
                                                    disabled={loading}
                                                    className={errors.phoneNumber ? "is-invalid" : ""}
                                                />
                                                {errors.phoneNumber && (
                                                    <span className="login-field-error">{errors.phoneNumber}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="password">کلمه عبور</label>
                                                <input
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    value={password}
                                                    onChange={this.handleChange}
                                                    placeholder="کلمه عبور خود را وارد کنید"
                                                     autoComplete='off'
                                                    disabled={loading}
                                                    className={errors.password ? "is-invalid" : ""}
                                                />
                                                {errors.password && (
                                                    <span className="login-field-error">{errors.password}</span>
                                                )}
                                            </div>

                                            <div className="login-actions">
                                                <button
                                                    type="submit"
                                                    className="login-btn"
                                                    disabled={loading}
                                                >
                                                    ورود
                                                </button>
                                                <a
                                                    href="/forgot-password"
                                                    className="login-forgot"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.context.fNavigate("/forgot-password");
                                                    }}
                                                >
                                                    کلمه عبور خود را فراموش کرده‌اید؟
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {footer(true)}
                </div>
            </HelmetProvider>
        );
    }
}

export default withRouter(Login);